function human (value: number, displayCents: boolean = false, noSymbol: boolean = false) {
    let curr = new Intl.NumberFormat('en-US', { 
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: (displayCents) ? 0 : 2,
        currency: 'AUD' }).format(value / 100);
  
        if (noSymbol) curr = curr.replace("$", "");

        return curr;
}

export { human }